import { useState, useRef } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import EditDrawer from './EditDrawer';
import DataTable from '../../components/DataTable';
import Operator from '../../components/Operator';
import SideNav from '../../components/SideNav';
import PageTransition from '../../components/PageTransition';

export default function SubAccount() {
  const dataTableRef = useRef(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleAddSuccess = () => {
    setDrawerOpen(false);
    if (dataTableRef.current?.refresh) {
      dataTableRef.current.refresh();
    }
  };

  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Operator
          record={record}
          onRemove={() => {
            if (dataTableRef.current?.refresh) {
              dataTableRef.current.refresh();
            }
          }}
          removeAPI={'/events/org/sub/account'}
        />
      ),
    },
  ];

  return (
    <PageTransition>
      <SideNav />
      <main className="flex-1 min-w-0">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-2xl font-bold text-slate-900 text-left">
                我的子账户
              </h1>
              <p className="text-slate-600 text-sm mt-1">
                管理和维护您的子账户
              </p>
            </div>
            <button
              onClick={() => setDrawerOpen(true)}
              className="h-9 flex items-center justify-center gap-2 px-4 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 shadow-sm transition-colors cursor-pointer mb-4"
            >
              <PlusOutlined />
              <span>新增账户</span>
            </button>
          </div>
          <DataTable
            ref={dataTableRef}
            columns={columns}
            api={'/events/org/sub/account/list'}
          />
        </div>
        <EditDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          onSave={handleAddSuccess}
        />
      </main>
    </PageTransition>
  );
}
